import { IAppState } from '../../../../../AppModulesWrapper';
import { EPlacingType } from '../../../../types/reducers/publishTerms';
import { createSelector } from 'reselect';
import { selectActivePackage } from '../../publicationPackages/selectors';
import { IPackage } from '../../publicationPackages/types';

export const selectActivePlacingType = createSelector(
  (state: IAppState) => selectActivePackage(state),
  (activePackage: IPackage | null): EPlacingType => {
    return activePackage ? EPlacingType.package : EPlacingType.balance;
  },
);
